import { useEffect, useState } from "react";
import { getStorage, STORAGE } from "../../../utils/storage";
import { ConfirmButton } from "../../../components/ConfirmButton";
import { api } from "../../../env";

export default function UnlockNextChapter({anyLocked, matchId}) {

    const [isMentor, setIsMentor] = useState(false)
    useEffect(() => setIsMentor(getStorage(STORAGE.USER_ROLE) == 'Mentor'))

    const unlock = () => {
        if (!matchId) return
        api.put(`matches/${matchId}/unlock-next-chapter`)
            .then(_ => { window.location.reload() })
            .catch(_ => {})
    }

    return(<>
        {anyLocked && isMentor && <div className="card">
            <p className="card-title v-spacer-xs">Unlock next Month</p>
            <p className="card-label neutral v-spacer-xs"> If you think that Mentee is ready for the next month you can <span className="bold">unlock it before it auto-unlocks.</span></p>
            <div className="flex justify-end"> <ConfirmButton label={'Unlock Next Month'} className={'solid'} onClick={unlock}/> </div>
        </div>}
    </>)
}